<template>
    <div v-if="item" class="md-content">
        <toolbar title="Édition du client" isSave="true" @save="dataSave" />
        <div class="md-mt-5 md-layout md-gutter md-alignment-top-center">

            <div class="md-layout-item md-size-90 ">
                <div class="md-layout md-alignment-top-right">
                    <md-switch v-model="item.isActive" class="md-primary">Actif</md-switch>
                </div>
            </div>
            
            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <span class="md-title">Information Général</span>
                <md-field :class="$v.item.uId|validations">
                    <label for="txtUId">Identifiant</label>
                    <md-input id="txtUId" v-model="item.uId" type="text" required />
                </md-field>
                <md-field :class="$v.item.name|validations">
                    <label for="txtName">Nom</label>
                    <md-input id="txtName" v-model="item.name" type="text" required />
                </md-field>
                <md-field>
                    <label for="txtlegalName">Nom legal</label>
                    <md-input id="txtlegalName" v-model="item.legalName" type="text" />
                </md-field>

                <div class="md-layout">
                    <field-type class="md-layout-item md-small-size-100 md-mr-3 " title="Type de compte" v-bind:item.sync="item" property="typeId" @md-selected="onTypeSelected" :defaultValue="null" sourceURI="sale/accountTypes" :expand="false" :readonly="false" />
                    <md-field class="md-layout-item md-small-size-100 ">
                        <label for="txtSortingKey">Clé de tri</label>
                        <md-input id="txtSortingKey" v-model="item.sortingKey" type="text" />
                    </md-field>
                </div>
                <field-address v-bind:item.sync="item.address" mode="edit" title="Adresse"  :includeType="true" :includeDescription="false" />

                <div class="md-layout md-layout-item md-size-100">
                    <span class="md-title">Notes</span>
                </div>
                <div class="md-layout-item md-size-100">
                    <label>Bientôt disponible</label>
                </div>

            </div>            
            
            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <field-phone title="Téléphone" mode="edit" v-bind:item.sync="item.phone" :required="true" :includeDescription="true" :readonly="false" />
                <field-email title="Courriel" mode="edit" v-bind:item.sync="item.email" :includeDescription="true" :readonly="false" />
                <field-contact title="Contact" mode="edit" v-bind:item.sync="item.contact" :includeDescription="true" :readonly="false" />
                <div class="md-mt-3">
                    <span class="md-title">Commentaires</span>
                    <md-field>
                        <md-textarea name="txtComment" id="txtComment" v-model="item.comment" type="textarea" />
                    </md-field>                
                </div>
            </div>

            
            <div class="md-layout-item md-size-90 md-mt-5">
                <span class="md-title">Autres informations</span>
            </div>
            <div class="md-layout-item md-size-90">
                <div class="md-layout-item ">
                    <md-tabs :md-active-tab="activeTab" class="md-transparent" @md-changed="onTabChanged">

                        <md-tab id="tab-Divers" name="tab-Divers" md-label="Général" md-icon="description">
                            <div class="md-layout md-gutter md-alignment-top-center">

                                <div class="md-layout-item md-size-50 md-small-size-90 ">
                                    <field-culture title="Language" mode="edit" v-bind:item.sync="item" property="lcid" :defaultValue="null" :expand="false" />
                                </div>

                                <div class="md-layout-item md-size-50 md-small-size-90 ">
                                    <label><b>Région:</b> Bientôt disponible</label><!-- {{item.region.title}} -->
                                </div>

                                <!-- <div class="md-layout-item md-size-50 md-small-size-90 ">
                                    <md-field>
                                        <label>Jour du prélèvement</label>
                                        <md-select v-model.number="item.debitDay">
                                            <md-option value="0">0</md-option>
                                            <md-option value="1">1</md-option>
                                            <md-option value="10">10</md-option>
                                            <md-option value="20">20</md-option>
                                        </md-select>
                                    </md-field>
                                </div> -->

                                <div class="md-layout-item md-size-50 md-small-size-90 ">
                                    <md-field>
                                        <label for="txtWebsite">Site web</label>
                                        <md-input id="txtWebsite" v-model="item.website" type="text" />
                                    </md-field>
                                </div>

                                <div class="md-layout-item md-size-50 md-small-size-90 ">
                                    <md-field>
                                        <label for="txtRN">Référence Id</label>
                                        <md-input id="txtRN" v-model="item.rn" type="text" />
                                    </md-field>
                                </div>
                                <!-- <div class="md-layout-item md-size-50 md-small-size-90 line-height">
                                    <md-datepicker v-model="item.lastNSFOn" v-format.date="item.lastNSFOn" md-immediately>
                                        <label>Dernier NSF le</label>
                                    </md-datepicker>
                                </div> -->
    

                                <!-- <div class="md-layout-item md-size-50 md-small-size-90 ">
                                    <md-datepicker v-model="item.overdueSince" v-format.date="item.overdueSince" md-immediately>
                                        <label>En retard depuis le</label>
                                    </md-datepicker>
                                </div> -->

                                <div class="md-layout-item md-size-50 md-small-size-90 ">
                                    <md-field>
                                        <label for="txtIndustry">Industrie</label>
                                        <md-input id="txtIndustry" v-model="item.industry" type="text" />
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-50 md-small-size-90 ">
                                    <md-field>
                                        <label for="txtSicCode">sicCode</label>
                                        <md-input id="txtSicCode" v-model="item.sicCode" type="text" />
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-50 md-small-size-90 ">
                                    <md-field :class="$v.item.numberOfEmploye|validations">
                                        <label for="txtNumberOfEmploye">Nombre d'employes</label>
                                        <md-input id="txtNumberOfEmploye" v-model.number="item.numberOfEmploye" type="text" />
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-50 md-small-size-90 ">
                                    <md-field :class="$v.item.annualRevenue|validations">
                                        <label for="txtAnnualRevenue">Revenu annuel</label>
                                        <md-input id="txtAnnualRevenue" v-model.number="item.annualRevenue" type="text" />
                                    </md-field>
                                </div>
                            </div>
                        </md-tab>

                        <md-tab id="tab-Phones" name="tab-Phones" md-label="Téléphones" md-icon="phone">
                            <accountPhone title="Téléphones" mode="edit" v-bind:accountId.sync="otherPhonesAccountId" @md-changed="(e)=> {this.item.otherPhones = e;}" />
                        </md-tab>

                        <md-tab id="tab-Emails" name="tab-Emails" md-label="Courriels" md-icon="mail">
                            <accountEmail title="Courriels" mode="edit" v-bind:accountId.sync="otherEmailsAccountId" @md-changed="(e)=> {this.item.otherEmails = e;}" />
                        </md-tab>

                        <md-tab id="tab-Addresses" name="tab-Addresses" md-label="Adresses" md-icon="home">
                            <accountAddress title="Adresses" mode="edit" v-bind:accountId.sync="otherAddressesAccountId" @md-changed="(e)=> {this.item.otherAddresses = e;}" />
                        </md-tab>

                        <md-tab id="tab-Notes" name="tab-Notes" md-label="Notes" md-icon="sticky_note_2">
                            <span class="md-subheading">Bientôt disponible</span>
                            <!-- <accountNote v-bind:items.sync="notes" v-bind:accountId.sync="item.id"></accountNote> -->
                        </md-tab>
                    </md-tabs>
                </div>
            </div>


            <!-- <div class="md-layout-item md-size-90 md-mt-5">
                <span class="md-title">Abonnements</span>
            </div>
            <div class="md-layout-item md-size-90">
                <div class="md-layout-item ">
                    <md-tabs class="md-transparent" @md-changed="onTabChanged">
                        <md-tab id="tab-Status" name="tab-Status" md-label="Statut" md-icon="query_stats">
                            <span class="md-subheading">Bientôt disponible</span>
                        </md-tab>                        

                        <md-tab id="tab-Services" name="tab-Services" md-label="Services" md-icon="plumbing">
                            <span class="md-subheading">Bientôt disponible</span>
                        </md-tab>

                        <md-tab id="tab-Ajustment" name="tab-Ajustment" md-label="Ajustement" md-icon="money">
                            <span class="md-subheading">Bientôt disponible</span>
                        </md-tab>

                        <md-tab id="tab-PaymentMethod" name="tab-PaymentMethod" md-label="Méthode de paiement" md-icon="credit_card">
                            <span class="md-subheading">Bientôt disponible</span>
                        </md-tab>

                        <md-tab id="tab-Billing" name="tab-Billing" md-label="Facturation" md-icon="receipt_long">
                            <accountBilling title="Facturation" mode="view" v-bind:accountId.sync="invoicesAccountId"  />
                        </md-tab>
                    </md-tabs>
                </div>
            </div>             -->

            <div class="md-layout-item md-size-90 md-mt-5 ">
                <label class="md-label">Modifié&nbsp;le:&nbsp;{{item.modifiedOn| YYYYMMDD}} </label>
                <label class="md-label">Par:&nbsp;{{item.modifiedBy}}</label>
            </div>
            <div class="md-layout-item md-size-90 ">
                <label class="md-label">Créé&nbsp;le:&nbsp;{{item.createdOn| YYYYMMDD}} </label>
                <label class="md-label">Par:&nbsp;{{item.createdBy}}</label>
            </div>
        </div>
    </div>

</template>

<style scoped>
    .md-primary {
        color: var(--md-theme-default-primary);
    }
    label {
        color: rgba(0, 0, 0, 0.54);
        font-size: 16px;
    }    
</style>

<script>
    import { required, requiredIf, minLength, between, numeric } from 'vuelidate/lib/validators'
    import baseToolbar from '@/components/toolbarBase.vue';

    import { autorisationExtension } from '@/mixins/autorisationExtension.js';
    import { beforeRouteLeaveExtension } from '@/mixins/beforeRouteLeaveExtension.js';
    import { navigateRouteExtension } from '@/mixins/navigateRouteExtension.js';

    import { apiSaleAccountExtension } from '@/mixins/apiSaleAccountExtension.js';

    import field_type from '@/components/field-select-wd.vue';
    import field_culture from '@/components/field-culture.vue';
    import field_address from '@/components/address.vue';
    import field_phone from '@/components/phone.vue';
    import field_email from '@/components/email.vue';
    import field_contact from '@/components/contact.vue';

    //import accountBilling from './account-billing.vue';
    import accountAddress from './account-address.vue';
    import accountEmail from './account-email.vue';
    import accountPhone from './account-phone.vue';

    export default {
        name: 'accountEdit',
        mixins: [autorisationExtension, beforeRouteLeaveExtension, navigateRouteExtension, apiSaleAccountExtension],
        data: () => ({
            //regions: [],
            id: null,
            item: null,
            invoicesAccountId: null,
            otherAddressesAccountId: null,
            otherEmailsAccountId: null,
            otherPhonesAccountId: null,
            activeTab: null,

            //notes: null,
            keywords: "",
            conditions: { recentAccountId: null }
        }),
        computed: { },
        watch: {
            item: {
                deep: true,
                handler(item) {
                    if (this.$v.$init && !this.$v.$anyDirty) {
                        if (this.$v.$initData != JSON.stringify(this.item)) {
                            this.$v.$touch();
                        }

                    }
                    if (!this.$v.$init) {
                        this.$v.$initData = JSON.stringify(this.item);
                        this.$v.$init = true;
                    }
                }
            }
        },
        validations: {
            item: {
                uId: { required },
                name: { required },
                numberOfEmploye: { required, numeric },
                annualRevenue: { required, numeric },
            }
        },
        created: function () {
            $App.event.$on("app_hotkey_ctrlS", this.onCtrlS);
        },
        destroyed: function () {
            $App.event.$off("app_hotkey_ctrlS", this.onCtrlS);
        },
        beforeMount: async function () {
        },
        mounted:
            async function () {

                this.id = this.$route.params.id;
                await this.dataRead();

                // await this.notesRead();
                // await this.regionsRead();

                this.conditions.recentAccountId = this.item.id; // here because didnt work in dataRead (cause await)
            },
        methods: {
            dataRead: async function () {
                let data = await this.SaleAccountGetByIdExpanded(this.id);
                if (data) {

                    if (data.lastNSFOn) { data.lastNSFOn = new Date(data.lastNSFOn); }
                    if (data.overdueSince) { data.overdueSince = new Date(data.overdueSince); }

                    this.item = data;
                }
            },
            dataSave: async function (bContinue) {

                this.$v.$touch()
                if (!this.$v.$invalid) {

                    let data = await this.SaleAccountSave(this.item);
                    if (data) {

                        if(this.item.id == 0 && data.id != 0) {
                            console.log('emit app_account_created');
                            $App.event.$emit("app_account_created", data);
                         }

                         if(!bContinue || bContinue == false ) {
                            this.$v.$reset();
                            this.navigateBack({ name: 'account_List' });
                        } else { 

                            this.$v.$reset();
                            this.$v.$init = false;
                            this.$v.$initData = null;

                            this.invoicesAccountId =  null;
                            this.otherAddressesAccountId = null;
                            this.otherEmailsAccountId = null;
                            this.otherPhonesAccountId= null;
                            
                            // get active tab...
                            let tab = this.activeTab;

                            this.id = data.id;
                            await this.dataRead();

                            // reset active tab...
                            this.onTabChanged(tab);

                        }

                    }
                }
            },

            onTabChanged: async function (activeTab) {

            this.activeTab = activeTab;

            if (activeTab) {
                switch (activeTab) {
                    case "tab-Phones":
                        this.otherPhonesAccountId = this.item.id;
                    break;
                    case "tab-Emails":
                        this.otherEmailsAccountId = this.item.id;
                    break;
                    case "tab-Addresses":
                        this.otherAddressesAccountId = this.item.id;
                    break;
                    case "tab-Billing":
                        this.invoicesAccountId = this.item.id;
                        break;
                    default:
                        break;
                }
            }
        },

            onTypeSelected: function(e) {
                console.log(e);
                this.item.type = e;
            },
            onCtrlS: function (e) {
                this.dataSave(true);
            }

        },
        components: {
            toolbar: baseToolbar,
            'field-type' : field_type,
            'field-culture' : field_culture,
            'field-address': field_address,
            'field-phone' : field_phone,
            'field-email' : field_email,
            'field-contact' : field_contact,
            //accountBilling : accountBilling,
            accountAddress : accountAddress,
            accountEmail : accountEmail,
            accountPhone : accountPhone

        }
    }
</script>